import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  AccountingConnection,
  OrganizationConfig,
  OrganizationConfigRevenueAccount
} from '../../../../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../utils';


@Component({
  selector: 'app-configure-revenue-accounts-modal',
  templateUrl: './configure-revenue-accounts-modal.component.html',
  styleUrls: ['./configure-revenue-accounts-modal.component.css']
})
export class ConfigureRevenueAccountsModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;
  @Input() conn: AccountingConnection;

  public inputAccountsText = '';
  public inputDepositAccountId = '';
  public inputDepositAccountName = '';

  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {
  }

  ngOnInit() {
    this.inputAccountsText = this.conn.revenue_accounts.map(
      acc => (acc.account_code.trim() !== '' ? acc.account_code : acc.account_id) + ',' + acc.account_name
    ).join('\n');

    this.inputDepositAccountId = this.conn.quickbooks_deposit_account_id;
    this.inputDepositAccountName = this.conn.quickbooks_deposit_account_name;
  }

  public handleSubmit() {
    this.errorMessage = '';

    const revenueAccounts: OrganizationConfigRevenueAccount[] = [];

    for (const inputAccountLine of this.inputAccountsText.split('\n')) {
      const inputAccountLineTrimmed = inputAccountLine.trim();

      if (inputAccountLineTrimmed === '') { continue; }

      const inputAccountParts = inputAccountLineTrimmed.split(',');

      if (inputAccountParts.length !== 2) {
        this.errorMessage = 'Invalid revenue account line: ' + inputAccountLine;
      }

      const accountCode = inputAccountParts[0].trim();
      const accountName = inputAccountParts[1].trim();

      revenueAccounts.push({
        account_code: accountCode,
        account_name: accountName,
        account_id: accountCode
      });
    }

    this.loadingSave = true;

    this.orgConfigService
      .setRevenueAccounts(
        this.conn,
        revenueAccounts,
        this.inputDepositAccountId,
        this.inputDepositAccountName
      )
      .then(() => {
        this.savedCallback({
          text: 'Revenue accounts updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingSave = false; });
  }

}
